import styled from "@emotion/styled";
import { FC, useState } from "react";
import { Field, useForm } from "react-final-form";

import { FormField, IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { countries } from "constants/recurly-countries";
import { useBreakpoints } from "hooks/use-breakpoints";
import { useTaxDetails } from "routes/subscription/contexts/tax-details-context";

import { ICardFormValues, getCardFormFieldError, hasCardFormFieldError, requiredCardFormFieldsErrors } from "./helpers";

const countryItems: IPickerListItem[] = countries.map(country => ({ key: country.countryCode, name: country.name }));

export const CountrySelectField: FC = () => {
  const { setCountry } = useTaxDetails();
  const [isFocused, setIsFocused] = useState(false);
  const form = useForm<ICardFormValues>();
  const { isMobile } = useBreakpoints();

  return (
    <Field
      name="country"
      validate={value => (value ? undefined : requiredCardFormFieldsErrors.country)}
      render={({ input, meta }) => (
        <HalfWidthFormField
          labelText="Country"
          labelFor={input.name}
          error={!isFocused ? getCardFormFieldError(meta) : undefined}
        >
          <Picker
            id={input.name}
            hideClearButton
            size={isMobile ? "large" : "medium"}
            clearSearchAfterSelection
            placeholder={isFocused ? "Search..." : ""}
            options={countryItems}
            selected={countryItems.filter(country => country.key === input.value)}
            onOpen={() => {
              setIsFocused(true);
            }}
            onClose={() => {
              setIsFocused(false);
              form.mutators.setFieldTouched(input.name, true);
            }}
            onSelect={selected => {
              if (selected) {
                setCountry(selected[0].key);
                input.onChange(selected[0].key);
              }
            }}
            error={!isFocused && hasCardFormFieldError(meta)}
          />
        </HalfWidthFormField>
      )}
    />
  );
};

const HalfWidthFormField = styled(FormField)`
  width: 50%;
`;
